/* TWB Radio — generative WebAudio radio engine + draggable window.
   Ported from 'Home v3.dc.html' (radio window lines 1122-1162, engine 1708-1791,
   persistRadio/restoreRadio 1808-1846, controls 1900-1935 / 2525-2558) and
   'RadioWidget.dc.html'. Owns window.TWBRadio. Loaded on every page (defer). */
(function () {
  'use strict';

  /* ---------- data (verbatim from the design) ---------- */

  var CHANNELS = [
    { id: 'podcast', label: 'Podcast' },
    { id: 'tapes', label: 'Work tapes' },
    { id: 'naptime', label: 'Naptime' }
  ];

  var TRACKS = {
    podcast: [
      { title: 'EP.041 — The lean stack: one founder, three AIs', len: '38:12' },
      { title: 'EP.039 — Why most productivity advice makes it worse', len: '31:47' },
      { title: 'EP.036 — Pricing without flinching', len: '29:05' }
    ],
    tapes: [
      { title: 'Vol.4 — balearic, no lyrics, good for spreadsheets', len: '58:00' },
      { title: 'Vol.3 — italo disco for inbox zero', len: '47:30' },
      { title: 'Vol.2 — dub for deep work', len: '61:15' }
    ],
    naptime: [
      { title: 'Tape 1 — ambient for the 3am feed', len: '44:00' },
      { title: 'Tape 2 — quiet piano for pram laps', len: '39:20' }
    ]
  };

  /* deco() of the riviera theme from Home v3.dc.html — the built-in default */
  var RIVIERA = {
    paper: '#FDF6E3', field: '#FFFDF6', ink: '#43342B', sub: '#5C4C40', mut: '#8A7A6D',
    accentA: '#F4A09C', accentB: '#7FC8C2', accentC: '#F5C97B', onAccent: '#43342B',
    shadow: '5px 5px 0 rgba(67,52,43,0.9)',
    titleBg: 'repeating-linear-gradient(90deg, transparent 0 6px, rgba(67,52,43,0.12) 6px 7px)',
    titleInk: '#43342B',
    titlePill: '#FDF6E3',
    titleSep: '1.5px solid #43342B',
    winBorder: '1.5px solid #43342B',
    btnBorder: '1.5px solid #43342B',
    btnFace: '#FDF6E3',
    closeInk: '#43342B',
    radius: '0px', radiusTop: '0px',
    screenBg: '#43342B', screenInk: '#9FE3DC'
  };

  function merge() {
    var out = {};
    for (var i = 0; i < arguments.length; i++) {
      var src = arguments[i];
      if (src) for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) out[k] = src[k];
    }
    return out;
  }

  var tokens = merge(RIVIERA);

  var state = {
    open: false,
    channel: 'podcast',
    trackIdx: { podcast: 0, tapes: 0, naptime: 0 },
    deck: null, /* open Spotify tape (embed panel) or null */
    playing: false,
    progress: 0.32,
    volume: 5,
    speed: 1,
    pos: null
  };

  /* ---------- hydration from metaobjects ----------
     snippets/twb-radio-data.liquid emits a JSON blob keyed by channel:
       { "podcast":[{title,length,kind,src,listen}...], "tapes":[...], "naptime":[...] }
     A channel with real entries replaces the hardcoded defaults; a channel with
     none keeps today's generative behaviour. naptime is ALWAYS generative per the
     data contract — we keep its metaobject titles/lengths for display but never
     treat its entries as a real source, so playback always falls to the synth. */

  function hydrateTracks() {
    var node = document.querySelector('[data-twb-radio-tracks]');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent || '{}'); } catch (err) { return; }
    if (!data || typeof data !== 'object') return;
    ['podcast', 'tapes', 'naptime'].forEach(function (chan) {
      var rows = data[chan];
      if (!rows || !rows.length) return; /* empty channel -> keep defaults */
      var forceSynth = chan === 'naptime';
      TRACKS[chan] = rows.map(function (r) {
        var kind = (r.kind || '').toLowerCase();
        var src = r.src || '';
        /* naptime never plays a real source; neither does a row missing src */
        var playable = !forceSynth && !!src && (kind === 'file' || kind === 'url' || kind === 'soundcloud');
        /* spotify rows aren't an audio engine — they open the embed deck —
           but their kind/src must survive hydration for the row to know */
        var deckable = !forceSynth && !!src && kind === 'spotify';
        return {
          title: r.title || '',
          len: r.length || '',
          kind: playable || deckable ? kind : '',
          src: playable || deckable ? src : '',
          listen: r.listen || ''
        };
      });
    });
    if (data.links && typeof data.links === 'object') _radioLinks = data.links;
  }

  /* ---------- generative WebAudio engine (exact port) ---------- */

  var _actx = null, _master = null, _audioEl = null, _seqTimer = null;
  /* _audioRawSrc: the exact string we last assigned to _audioEl.src — comparing
     against a.src would pit the browser's RESOLVED url against the raw
     metaobject value and spuriously mismatch on non-canonical urls.
     _pendingMeta: the one armed loadedmetadata seek handler, so an aborted
     load can never leak its seek fraction onto the next track.
     _progressReal: state.progress starts life as a DECORATIVE 0.32 for the
     idle bar — only a restored save or genuine playback may arm resume-seek. */
  var _audioRawSrc = null, _pendingMeta = null, _progressReal = false;

  function rng(seed) {
    var t = seed;
    return function () {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ t >>> 15, 1 | t);
      r ^= r + Math.imul(r ^ r >>> 7, 61 | r);
      return ((r ^ r >>> 14) >>> 0) / 4294967296;
    };
  }

  function ensureAudio() {
    if (_actx) return;
    var Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    _actx = new Ctx();
    _master = _actx.createGain();
    _master.gain.value = (state.volume || 5) / 12;
    _master.connect(_actx.destination);
  }

  /* stop ONLY the generative synth sequencer */
  function stopSynth() {
    clearInterval(_seqTimer);
    _seqTimer = null;
  }

  /* ---------- real-source playback (<audio> element + SoundCloud) ----------
     Exactly one source ever plays. _activeSource records which engine owns the
     transport/progress so the dumb progress tick stands down for real audio. */

  var _activeSource = null; /* 'audio' | 'soundcloud' | 'synth' | null */
  var _radioLinks = null;   /* { spotify, apple } — "listen on" links, podcast channel */
  var _scWidget = null, _scIframe = null, _scReady = false, _scLoading = false,
      _scPendingUrl = null, _scWantPlay = false;
  var SC_API = 'https://w.soundcloud.com/player/api.js';

  /* ---- <audio> element (kind = file | url) ---- */

  function ensureAudioEl() {
    if (_audioEl) return _audioEl;
    _audioEl = new Audio();
    /* NO crossOrigin: plain playback of cross-origin MP3s (podcast CDNs,
       SoundCloud media, etc.) must NOT request CORS — almost none send the
       headers, and setting it 'anonymous' makes the element error before play.
       We only play these files, never WebAudio-analyse them, so CORS is moot. */
    _audioEl.preload = 'auto';
    _audioEl.addEventListener('timeupdate', function () {
      if (_activeSource !== 'audio') return;
      var d = _audioEl.duration;
      if (d && isFinite(d) && d > 0) {
        state.progress = Math.max(0, Math.min(1, _audioEl.currentTime / d));
        _progressReal = true;
        paintProgress();
      }
    });
    _audioEl.addEventListener('ended', function () {
      if (_activeSource === 'audio') setIdx(1);
    });
    return _audioEl;
  }

  function playFile(track) {
    var a = ensureAudioEl();
    scPause();
    stopSynth();
    _activeSource = 'audio';
    if (_audioRawSrc !== track.src) {
      _audioRawSrc = track.src;
      /* a new load aborts any pending one WITHOUT firing loadedmetadata —
         disarm the previous seek handler or it fires on the wrong track */
      if (_pendingMeta) { a.removeEventListener('loadedmetadata', _pendingMeta); _pendingMeta = null; }
      a.src = track.src;
      /* fresh load: resume at the saved position (cross-session, or reopening
         after a full close) when it's meaningful. New-track picks sit at ~0.02
         and start from the top. An already-loaded track is left untouched, so
         reopening / un-minimising never restarts the episode. _progressReal
         keeps the decorative idle-bar 0.32 from seeding a first-ever play. */
      var seek = state.progress;
      if (_progressReal && typeof seek === 'number' && seek > 0.05 && seek < 0.999) {
        var onMeta = function () {
          a.removeEventListener('loadedmetadata', onMeta);
          _pendingMeta = null;
          if (isFinite(a.duration) && a.duration > 0) { try { a.currentTime = seek * a.duration; } catch (e) {} }
        };
        _pendingMeta = onMeta;
        a.addEventListener('loadedmetadata', onMeta);
      }
    }
    a.volume = (state.volume || 5) / 8;
    try { a.playbackRate = state.speed || 1; } catch (e) {}
    var p = a.play();
    if (p && p.catch) p.catch(function () {}); /* autoplay may be blocked; user click resumes */
  }

  /* ---- SoundCloud Widget API (kind = soundcloud), driven headlessly ---- */

  function ensureScScript(cb) {
    if (window.SC && window.SC.Widget) { cb(); return; }
    if (_scLoading) {
      var t = setInterval(function () {
        if (window.SC && window.SC.Widget) { clearInterval(t); cb(); }
      }, 80);
      return;
    }
    _scLoading = true;
    var s = document.createElement('script');
    s.src = SC_API;
    s.async = true;
    s.onload = function () { cb(); };
    s.onerror = function () { _scLoading = false; scFallback(); };
    document.head.appendChild(s);
  }

  function ensureScIframe() {
    if (_scIframe) return _scIframe;
    var f = document.createElement('iframe');
    f.setAttribute('allow', 'autoplay');
    f.setAttribute('title', 'TWB Radio (SoundCloud)');
    /* keep it in the DOM but never visible — the orange UI must stay hidden */
    f.style.cssText = 'position:absolute; width:1px; height:1px; left:-9999px; top:-9999px; border:0; opacity:0; pointer-events:none;';
    document.body.appendChild(f);
    _scIframe = f;
    return f;
  }

  function scLoadAndPlay(url) {
    _scPendingUrl = url;
    _scWantPlay = true;
    ensureScScript(function () {
      var f = ensureScIframe();
      if (!_scWidget) {
        f.src = 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(url) +
          '&visual=false&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_teaser=false&buying=false&sharing=false&download=false';
        _scWidget = window.SC.Widget(f);
        bindScWidget();
      } else if (_scReady) {
        loadScUrl(url);
      } else {
        /* widget exists but not READY yet — defer; READY handler will load+play */
        _scPendingUrl = url;
      }
    });
  }

  function bindScWidget() {
    var w = _scWidget, EV = window.SC.Widget.Events;
    w.bind(EV.READY, function () {
      _scReady = true;
      w.setVolume(((state.volume || 5) / 8) * 100);
      if (_scPendingUrl) { loadScUrl(_scPendingUrl); }
      else if (_scWantPlay) { w.play(); }
    });
    w.bind(EV.PLAY_PROGRESS, function (e) {
      if (_activeSource !== 'soundcloud') return;
      if (e && typeof e.relativePosition === 'number') {
        state.progress = Math.max(0, Math.min(1, e.relativePosition));
        _progressReal = true;
        paintProgress();
      }
    });
    w.bind(EV.FINISH, function () {
      if (_activeSource === 'soundcloud') setIdx(1);
    });
    w.bind(EV.ERROR, function () { scFallback(); });
  }

  function loadScUrl(url) {
    if (!_scWidget) return;
    _scWidget.load(url, {
      auto_play: _scWantPlay,
      visual: false,
      hide_related: true,
      show_comments: false,
      show_user: false,
      show_teaser: false,
      buying: false,
      sharing: false,
      download: false,
      callback: function () {
        _scWidget.setVolume(((state.volume || 5) / 8) * 100);
        if (_scWantPlay) _scWidget.play();
      }
    });
    _scPendingUrl = null;
  }

  function playSoundcloud(track) {
    if (_audioEl) { try { _audioEl.pause(); } catch (e) {} }
    stopSynth();
    _activeSource = 'soundcloud';
    _scWantPlay = true;
    scLoadAndPlay(track.src);
  }

  function scPause() {
    _scWantPlay = false;
    if (_scWidget && _scReady) { try { _scWidget.pause(); } catch (e) {} }
  }

  function scResume() {
    _scWantPlay = true;
    if (_scWidget && _scReady) { try { _scWidget.play(); } catch (e) {} }
  }

  /* embed-disabled / API failure: surface the title + a subtle open-on-soundcloud link */
  function scFallback() {
    if (_activeSource === 'soundcloud') _activeSource = null;
    var cur = currentTrack();
    if (refs.screenText) {
      refs.screenText.textContent = '⚠ ' + (cur.title || 'track unavailable');
    }
    showFallbackLink(cur);
  }

  function showFallbackLink(track) {
    if (!refs.fallback) return;
    refs.fallback.textContent = '';
    var url = (track && (track.listen || track.src)) || '';
    if (!url) { refs.fallback.style.display = 'none'; return; }
    var a = el('a',
      'font-size: 9px; letter-spacing: 0.06em; text-decoration: underline; color: ' + tokens.screenInk + '; opacity: 0.85;',
      'open on soundcloud ↗');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    refs.fallback.appendChild(a);
    refs.fallback.style.display = 'block';
  }

  function clearFallbackLink() {
    if (refs.fallback) { refs.fallback.textContent = ''; refs.fallback.style.display = 'none'; }
  }

  /* seek the active real source to a 0..1 fraction (no-op for the synth) */
  function seekTo(frac) {
    _progressReal = true; /* an explicit scrub is a real position */
    if (_activeSource === 'audio' && _audioEl) {
      var d = _audioEl.duration;
      if (d && isFinite(d) && d > 0) {
        _audioEl.currentTime = frac * d;
        state.progress = frac;
        paintProgress();
      }
    } else if (_activeSource === 'soundcloud' && _scWidget && _scReady) {
      _scWidget.getDuration(function (ms) {
        if (ms && ms > 0) {
          _scWidget.seekTo(frac * ms);
          state.progress = frac;
          paintProgress();
        }
      });
    }
  }

  function startAudio(chan, idx) {
    var track = (TRACKS[chan] || [])[idx] || {};
    clearFallbackLink();
    /* real source -> dedicated engine; naptime/no-src -> generative synth */
    if (track.src && track.kind === 'soundcloud') { playSoundcloud(track); return; }
    if (track.src && (track.kind === 'file' || track.kind === 'url')) { playFile(track); return; }

    /* ----- generative engine (unchanged behaviour) ----- */
    ensureAudio();
    if (!_actx) return;
    if (_actx.state === 'suspended') _actx.resume();
    stopSynth();
    /* a different engine may have been playing — silence it */
    if (_audioEl) { try { _audioEl.pause(); } catch (e) {} }
    scPause();
    _activeSource = 'synth';
    var ctx = _actx;
    var master = _master;
    var cfgs = {
      podcast: { tempo: 290, base: 175, scale: [0, 3, 5, 7, 10, 12], wave: 'triangle', noteLen: 0.55, density: 0.5, padEvery: 14, padLen: 4.5 },
      tapes: { tempo: 170, base: 220, scale: [0, 2, 4, 7, 9, 12, 14], wave: 'triangle', noteLen: 0.24, density: 0.85, padEvery: 24, padLen: 5.5 },
      naptime: { tempo: 540, base: 262, scale: [0, 2, 4, 7, 9], wave: 'sine', noteLen: 1.8, density: 0.65, padEvery: 10, padLen: 7 }
    };
    var cfg = cfgs[chan] || cfgs.tapes;
    var rnd = rng((chan === 'podcast' ? 11 : chan === 'tapes' ? 47 : 83) + idx * 17);
    var step = 0;
    var playNote = function (freq, t, len, vol, wave) {
      var o = ctx.createOscillator();
      var g = ctx.createGain();
      o.type = wave;
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.04);
      g.gain.exponentialRampToValueAtTime(0.0001, t + len);
      o.connect(g);
      g.connect(master);
      o.start(t);
      o.stop(t + len + 0.1);
    };
    _seqTimer = setInterval(function () {
      if (!state.playing) return;
      var t = ctx.currentTime + 0.05;
      if (rnd() < cfg.density) {
        var deg = cfg.scale[Math.floor(rnd() * cfg.scale.length)];
        var oct = rnd() < 0.3 ? 2 : 1;
        playNote(cfg.base * Math.pow(2, deg / 12) * oct, t, cfg.noteLen, 0.11, cfg.wave);
      }
      if (step % cfg.padEvery === 0) {
        var root = (cfg.base / 2) * Math.pow(2, cfg.scale[Math.floor(rnd() * 3)] / 12);
        [1, 1.5, 2].forEach(function (m) { playNote(root * m, t, cfg.padLen, 0.045, 'sine'); });
      }
      step++;
    }, cfg.tempo);
  }

  /* pause whichever engine is live, leaving position intact so play() resumes */
  /* ---------- Spotify tape deck (kind = spotify) ----------
     A tape row whose source is a Spotify playlist/album opens Spotify's
     official embed inside the radio window: full playback for logged-in
     Premium visitors, 30s previews otherwise. Our engines pause first. */
  function spotifyEmbedUrl(url) {
    var m = String(url || '').match(/open\.spotify\.com\/(playlist|album|track|artist|show|episode)\/([A-Za-z0-9]+)/);
    return m ? 'https://open.spotify.com/embed/' + m[1] + '/' + m[2] + '?theme=0' : null;
  }
  /* Spotify iFrame API: lets OUR transport drive the embed (play/pause) and
     feeds its progress into our dotted bar. Loads lazily; if it never arrives
     the deck still renders as a plain embed (graceful fallback). */
  var _spApi = null, _spApiLoading = false, _deckCtl = null, _deckCtlEl = null;
  var _deckMountedFor = null, _deckShellEl = null; /* stable-mount guard: sync() must never rebuild a live deck */
  function ensureSpotifyApi(cb) {
    if (_spApi) { cb(); return; }
    window.onSpotifyIframeApiReady = function (api) { _spApi = api; cb(); };
    if (_spApiLoading) return;
    _spApiLoading = true;
    var sc = document.createElement('script');
    sc.src = 'https://open.spotify.com/embed/iframe-api/v1';
    sc.async = true;
    document.head.appendChild(sc);
  }
  function spotifyUri(url) {
    var m = String(url || '').match(/open\.spotify\.com\/(playlist|album|track|artist|show|episode)\/([A-Za-z0-9]+)/);
    return m ? 'spotify:' + m[1] + ':' + m[2] : null;
  }
  function destroyDeckCtl() {
    if (_deckCtl) { try { _deckCtl.destroy(); } catch (e) {} }
    _deckCtl = null; _deckCtlEl = null;
    _deckMountedFor = null; _deckShellEl = null;
    if (_activeSource === 'spotify') _activeSource = null;
  }
  function openDeck(track) {
    state.deck = track;
    state.playing = false;
    pauseAudio();
    persistRadio({ playing: false });
    tapeSpin();
    render();
  }
  function closeDeck() {
    destroyDeckCtl();
    state.deck = null;
    state.playing = false;
    render();
  }
  function currentIsSpotify() {
    var t = currentTrack();
    return (t.kind || '') === 'spotify';
  }

  function pauseAudio() {
    stopSynth();
    if (_audioEl) { try { _audioEl.pause(); } catch (e) {} }
    scPause();
    if (_actx && _actx.state === 'running') _actx.suspend();
  }

  /* ---------- persistence ---------- */

  function persistRadio(overrides) {
    try {
      var s = {
        open: state.open,
        channel: state.channel,
        trackIdx: state.trackIdx,
        playing: state.playing,
        progress: state.progress,
        speed: state.speed || 1
      };
      if (overrides) for (var k in overrides) if (Object.prototype.hasOwnProperty.call(overrides, k)) s[k] = overrides[k];
      localStorage.setItem('twb-radio', JSON.stringify(s));
    } catch (err) {}
  }

  function restoreRadio() {
    try {
      var raw = localStorage.getItem('twb-radio');
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (!saved) return;
      /* channel / track / position restore even when the window was closed or
         minimised — the pill (or a later open) must pick up exactly where the
         listener left off, not reset to the default channel's first track */
      state.channel = saved.channel || 'podcast';
      state.trackIdx = saved.trackIdx || { podcast: 0, tapes: 0, naptime: 0 };
      if (typeof saved.progress === 'number') { state.progress = saved.progress; _progressReal = true; }
      if (typeof saved.speed === 'number' && saved.speed >= 1 && saved.speed <= 2) state.speed = saved.speed;
      if (!saved.open) return; /* stays closed; the restored spot waits for the pill */
      state.open = true;
      state.playing = !!saved.playing;
      if (saved.playing) {
        var ch = saved.channel || 'podcast';
        startAudio(ch, (saved.trackIdx || {})[ch] || 0);
        /* autoplay is blocked until a user gesture — resume whichever engine
           is active on the first pointer/key event, then unbind. */
        var resume = function () {
          if (_actx && _actx.state === 'suspended') _actx.resume();
          if (state.playing) {
            if (_activeSource === 'audio' && _audioEl) {
              var p = _audioEl.play(); if (p && p.catch) p.catch(function () {});
            } else if (_activeSource === 'soundcloud') {
              scResume();
            }
          }
          window.removeEventListener('pointerdown', resume);
          window.removeEventListener('keydown', resume);
        };
        window.addEventListener('pointerdown', resume);
        window.addEventListener('keydown', resume);
      }
    } catch (err) {}
  }

  /* ---------- helpers ---------- */

  function getMode() {
    var m = document.documentElement.getAttribute('data-twb-entry');
    return m === 'os' || m === 'chooser' || m === 'site' ? m : 'site';
  }

  function currentList() { return TRACKS[state.channel] || []; }

  function currentIdx() {
    var list = currentList();
    return Math.min(state.trackIdx[state.channel] || 0, Math.max(0, list.length - 1));
  }

  function currentTrack() { return currentList()[currentIdx()] || { title: '', len: '' }; }

  function el(tag, cssText, text) {
    var n = document.createElement(tag);
    if (cssText) n.style.cssText = cssText;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- DOM: window + pill ---------- */

  var winEl = null, pillEl = null;
  var refs = {};

  function applyWinPos() {
    if (!winEl) return;
    if (state.pos) {
      winEl.style.left = state.pos.x + 'px';
      winEl.style.top = state.pos.y + 'px';
      winEl.style.right = 'auto';
      winEl.style.bottom = 'auto';
    } else {
      winEl.style.left = 'auto';
      winEl.style.top = 'auto';
      winEl.style.right = '28px';
      winEl.style.bottom = '58px';
    }
  }

  var _drag = null, _rsz = null;

  function buildWindow() {
    winEl = el('div',
      'position: fixed; z-index: 415; width: 340px; background: ' + tokens.paper +
      '; border: ' + tokens.winBorder + '; box-shadow: ' + tokens.shadow +
      '; border-radius: ' + tokens.radius + '; color: ' + tokens.ink + '; display: flex; flex-direction: column;');
    winEl.setAttribute('data-win', 'radio');
    winEl.setAttribute('data-front', '1');

    /* title bar (drag handle) */
    var bar = el('div',
      'height: 32px; border-bottom: ' + tokens.titleSep +
      '; display: flex; align-items: center; padding: 0 10px; gap: 10px; background: ' + tokens.titleBg +
      '; cursor: grab; touch-action: none; user-select: none; -webkit-user-select: none; border-radius: ' + tokens.radiusTop + ';');
    bar.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-hot]')) return;
      var rect = winEl.getBoundingClientRect();
      _drag = { dx: e.clientX - rect.left, dy: e.clientY - rect.top, sx: e.clientX, sy: e.clientY };
      state.pos = { x: rect.left, y: rect.top };
      applyWinPos();
      e.preventDefault();
    });

    var close = el('span',
      'width: 12px; height: 12px; border: 1.5px solid ' + tokens.ink + '; background: ' + tokens.accentA +
      '; color: ' + tokens.closeInk +
      '; display: flex; align-items: center; justify-content: center; font-size: 10px; line-height: 1; cursor: pointer; flex-shrink: 0;',
      '×');
    close.setAttribute('data-hot', 'true');
    close.className = 'twb-hov-fade6 twb-os-x';
    close.addEventListener('click', closeRadio);

    var title = el('span',
      'flex: 1; text-align: center; font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; background: ' +
      tokens.titlePill + '; color: ' + tokens.titleInk + '; padding: 0 10px;',
      'TWB Radio');

    /* the square is a MINIMISE control — collapses the radio (to the pill on
       site view, or out of the way in the OS) WITHOUT stopping playback. The
       × beside it is the hard stop/close. */
    var square = el('span',
      'width: 12px; height: 12px; border: 1.5px solid ' + tokens.ink + '; display: flex; align-items: flex-end; justify-content: center; flex-shrink: 0; cursor: pointer; padding: 0 0 2px 0; box-sizing: border-box;');
    square.innerHTML = '<span style="display: block; width: 7px; height: 1.5px; background: ' + tokens.ink + ';"></span>';
    square.setAttribute('data-hot', 'true');
    square.setAttribute('title', 'minimise — keeps playing');
    square.className = 'twb-hov-fade6 twb-os-x';
    square.addEventListener('click', function () { state.open = false; persistRadio({ open: false }); render(); });

    bar.appendChild(close);
    bar.appendChild(title);
    bar.appendChild(square);
    winEl.appendChild(bar);

    /* body */
    var body = el('div', 'padding: 16px 18px 18px 18px; flex: 1; min-height: 0; display: flex; flex-direction: column;');

    /* channel chips */
    var chipRow = el('div', 'display: flex; gap: 7px; flex-shrink: 0;');
    refs.chips = [];
    CHANNELS.forEach(function (c) {
      var b = el('button',
        "font-family: 'Space Mono', monospace; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; border: " +
        tokens.btnBorder + '; padding: 5px 9px; background: transparent; cursor: pointer; color: ' + tokens.ink + ';',
        c.label);
      b.className = 'twb-hov-fade';
      b.addEventListener('click', function () { selectChannel(c.id); });
      refs.chips.push({ id: c.id, btn: b });
      chipRow.appendChild(b);
    });
    body.appendChild(chipRow);

    /* screen */
    var screen = el('div',
      'margin-top: 14px; border: 1.5px solid ' + tokens.ink + '; background: ' + tokens.screenBg +
      '; color: ' + tokens.screenInk + '; padding: 11px 13px; font-size: 11px; letter-spacing: 0.04em; line-height: 1.5; flex-shrink: 0;');
    refs.screenText = document.createTextNode('');
    screen.appendChild(refs.screenText);
    var progRow = el('div', 'margin-top: 8px; display: flex; align-items: center; gap: 8px;');
    var barOuter = el('span', 'flex: 1; height: 4px; background: rgba(128,128,128,0.35); position: relative; display: block; cursor: pointer;');
    refs.fill = el('span', 'position: absolute; left: 0; top: 0; bottom: 0; width: 0%; background: ' + tokens.screenInk + '; display: block;');
    barOuter.appendChild(refs.fill);
    /* seek by clicking the bar — only meaningful for real sources */
    barOuter.addEventListener('click', function (e) {
      var rect = barOuter.getBoundingClientRect();
      if (rect.width <= 0) return;
      var frac = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      seekTo(frac);
    });
    refs.elapsed = el('span', 'font-size: 9px; flex-shrink: 0; opacity: 0.75; font-variant-numeric: tabular-nums;', '0:00');
    refs.len = el('span', 'font-size: 9px; flex-shrink: 0;');
    progRow.appendChild(refs.elapsed);
    progRow.appendChild(barOuter);
    progRow.appendChild(refs.len);
    screen.appendChild(progRow);
    /* fallback link slot (hidden until a SoundCloud embed fails) */
    refs.fallback = el('div', 'margin-top: 7px; display: none;');
    screen.appendChild(refs.fallback);
    body.appendChild(screen);

    /* transport */
    var transport = el('div', 'margin-top: 12px; display: flex; justify-content: center; gap: 9px; flex-shrink: 0;');
    var prev = el('button',
      'width: 42px; height: 32px; border: ' + tokens.btnBorder + '; background: ' + tokens.btnFace +
      "; display: flex; align-items: center; justify-content: center; font-size: 11px; cursor: pointer; font-family: 'Space Mono', monospace; color: " +
      tokens.ink + ';', '◀◀');
    prev.className = 'twb-hov-fade';
    prev.addEventListener('click', function () { setIdx(-1); });
    refs.playBtn = el('button',
      'width: 54px; height: 32px; border: ' + tokens.btnBorder + '; background: ' + tokens.accentC +
      "; display: flex; align-items: center; justify-content: center; font-size: 12px; cursor: pointer; font-family: 'Space Mono', monospace; color: " +
      tokens.onAccent + ';');
    refs.playBtn.className = 'twb-hov-fade';
    refs.playBtn.addEventListener('click', togglePlay);
    var next = el('button',
      'width: 42px; height: 32px; border: ' + tokens.btnBorder + '; background: ' + tokens.btnFace +
      "; display: flex; align-items: center; justify-content: center; font-size: 11px; cursor: pointer; font-family: 'Space Mono', monospace; color: " +
      tokens.ink + ';', '▶▶');
    next.className = 'twb-hov-fade';
    next.addEventListener('click', function () { setIdx(1); });
    transport.appendChild(prev);
    transport.appendChild(refs.playBtn);
    transport.appendChild(next);
    /* playback speed — cycles 1x -> 1.25x -> 1.5x -> 2x. Applies to real audio
       (file/url); the synth and SoundCloud politely ignore it. */
    refs.speedBtn = el('button',
      'width: 46px; height: 32px; border: ' + tokens.btnBorder + '; background: ' + tokens.btnFace +
      "; display: flex; align-items: center; justify-content: center; font-size: 10px; cursor: pointer; font-family: 'Space Mono', monospace; color: " +
      tokens.ink + ';', (state.speed || 1) + '\u00d7');
    refs.speedBtn.className = 'twb-hov-fade';
    refs.speedBtn.title = 'playback speed';
    refs.speedBtn.addEventListener('click', function () {
      var steps = [1, 1.25, 1.5, 2];
      state.speed = steps[(steps.indexOf(state.speed || 1) + 1) % steps.length];
      refs.speedBtn.textContent = state.speed + '\u00d7';
      if (_audioEl) { try { _audioEl.playbackRate = state.speed; } catch (e) {} }
      persistRadio();
    });
    transport.appendChild(refs.speedBtn);
    body.appendChild(transport);

    /* tracklist */
    refs.listWrap = el('div',
      'margin-top: 12px; border-top: 1px solid ' + tokens.mut + '; padding-top: 10px; display: flex; flex-direction: column; gap: 6px; flex: 1; min-height: 0; overflow-y: auto;');
    body.appendChild(refs.listWrap);

    /* "listen on" links — shown only on the podcast channel (populated in sync) */
    refs.linksRow = el('div',
      'margin-top: 12px; border-top: 1px solid ' + tokens.mut + '; padding-top: 10px; display: none; align-items: center; gap: 12px; font-size: 10px; letter-spacing: 0.06em; flex-shrink: 0;');
    body.appendChild(refs.linksRow);

    winEl.appendChild(body);
    /* resize handle (bottom-right) — drag to resize, like the OS windows */
    var rsz = el('div', 'position: absolute; bottom: 0; right: 0; width: 20px; height: 20px; cursor: nwse-resize; touch-action: none; display: flex; align-items: flex-end; justify-content: flex-end; padding: 0 3px 3px 0;');
    rsz.innerHTML = '<span style="width: 11px; height: 11px; background: repeating-linear-gradient(135deg, ' + tokens.ink + ' 0 1px, transparent 1px 4px); display: block; opacity: 0.55;"></span>';
    rsz.addEventListener('pointerdown', function (e) {
      _rsz = { startW: winEl.offsetWidth, startH: winEl.offsetHeight, sx: e.clientX, sy: e.clientY };
      e.preventDefault();
      e.stopPropagation();
    });
    winEl.appendChild(rsz);
    applyWinPos();
    (document.querySelector('#twb-os-root [data-os-radio-slot]') || document.body).appendChild(winEl);
    if (window.__twbOSRaise) window.__twbOSRaise('radio');
  }

  function renderTracklist() {
    if (!refs.listWrap) return;
    /* a live deck must survive sync() — rebuilding it would recreate the
       Spotify iframe and restart playback (the play/pause/skip glitch) */
    if (state.deck && _deckMountedFor === state.deck && _deckShellEl && _deckShellEl.parentNode === refs.listWrap) return;
    refs.listWrap.textContent = '';
    if (state.deck) {
      var topRow = el('div', 'display: flex; justify-content: space-between; align-items: baseline; gap: 10px; padding: 2px 0 8px 0;');
      var back = el('button', "font-family: 'Space Mono', monospace; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; border: none; background: none; padding: 0; cursor: pointer; text-align: left; color: " + tokens.ink + ';', '\u2190 back to tapes');
      back.className = 'twb-hov-fade';
      back.addEventListener('click', closeDeck);
      var out = el('a', 'font-size: 10px; font-family: \'Space Mono\', monospace; letter-spacing: 0.08em; color: ' + tokens.ink + '; flex-shrink: 0;', 'open in spotify \u2197');
      out.href = state.deck.src || state.deck.listen || '#';
      out.target = '_blank'; out.rel = 'noopener';
      out.className = 'twb-hov-fade';
      topRow.appendChild(back);
      topRow.appendChild(out);
      refs.listWrap.appendChild(topRow);
      /* cassette shell around the embed */
      var shell = el('div', 'border: ' + tokens.winBorder + '; background: ' + tokens.field + '; padding: 9px 10px 10px 10px;');
      var lbl = el('div', 'display: flex; justify-content: space-between; align-items: center; gap: 8px; padding: 0 2px 8px 2px;');
      lbl.appendChild(el('span', "font-family: 'Space Mono', monospace; font-size: 9px; letter-spacing: 0.18em; text-transform: uppercase; color: " + tokens.mut + '; white-space: nowrap; flex-shrink: 0;', '\u25c9 \u00b7 tape deck'));
      lbl.appendChild(el('span', "font-family: 'Space Mono', monospace; font-size: 9px; letter-spacing: 0.12em; text-transform: uppercase; color: " + tokens.mut + '; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;', 'side a \u00b7 ' + (state.deck.title || '')));
      lbl.appendChild(el('span', "font-family: 'Space Mono', monospace; font-size: 9px; letter-spacing: 0.18em; color: " + tokens.mut + '; flex-shrink: 0;', '\u25c9'));
      shell.appendChild(lbl);
      var mount = el('div', 'min-height: 152px;');
      shell.appendChild(mount);
      refs.listWrap.appendChild(shell);
      _deckMountedFor = state.deck;
      _deckShellEl = shell;
      var uri = spotifyUri(state.deck.src || state.deck.listen);
      var emb = spotifyEmbedUrl(state.deck.src || state.deck.listen);
      var plainEmbed = function () {
        if (!emb) return;
        mount.textContent = '';
        var fr = document.createElement('iframe');
        fr.src = emb;
        fr.setAttribute('allow', 'encrypted-media; fullscreen; picture-in-picture');
        fr.setAttribute('loading', 'lazy');
        fr.setAttribute('title', state.deck.title || 'work tape');
        fr.style.cssText = 'width: 100%; height: 300px; border: 0; display: block;';
        mount.appendChild(fr);
      };
      if (uri) {
        var wantTrack = state.deck;
        ensureSpotifyApi(function () {
          /* the deck may have closed / changed while the API loaded */
          if (state.deck !== wantTrack || !mount.isConnected || !_spApi) return;
          try {
            _spApi.createController(mount, { uri: uri, width: '100%', height: 300, theme: 'dark' }, function (ctl) {
              if (state.deck !== wantTrack) { try { ctl.destroy(); } catch (e) {} return; }
              _deckCtl = ctl; _deckCtlEl = mount;
              ctl.addListener('playback_update', function (e) {
                if (!e || !e.data || state.deck !== wantTrack) return;
                var playing = !e.data.isPaused;
                if (playing) _activeSource = 'spotify';
                if (state.playing !== playing) {
                  state.playing = playing;
                  /* direct paint — sync() would rebuild the tracklist */
                  if (refs.playBtn) refs.playBtn.textContent = playing ? '\u275a\u275a' : '\u25b6';
                  if (refs.screenText) refs.screenText.textContent = (playing ? '\u25b6' : '\u275a\u275a') + ' ' + (state.deck.title || '');
                }
                if (e.data.duration > 0) {
                  state.progress = Math.max(0, Math.min(1, e.data.position / e.data.duration));
                  _progressReal = true;
                  if (refs.elapsed) refs.elapsed.textContent = fmtTime(Math.floor(e.data.position / 1000));
                  if (refs.fill) refs.fill.style.width = (state.progress * 100).toFixed(1) + '%';
                }
              });
            });
          } catch (err) { plainEmbed(); }
        });
      } else { plainEmbed(); }
      return;
    }
    var idx = currentIdx();
    currentList().forEach(function (t, i) {
      var row = el('button',
        "display: flex; justify-content: space-between; gap: 10px; font-size: 10px; font-family: 'Space Mono', monospace; border: none; background: none; padding: 2px 0; cursor: pointer; text-align: left; color: " +
        (i === idx ? tokens.ink : tokens.mut) + ';');
      row.className = 'twb-hov-fade';
      row.addEventListener('click', function () { if ((t.kind || '') === 'spotify') openDeck(t); else playTrack(i); });
      var name = el('span', 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;',
        (i === idx ? '▸' : '·') + ' ' + t.title + ((t.kind || '') === 'spotify' ? ' \u2197' : ''));
      var lsec = parseLen(t.len);
      var len = el('span', 'flex-shrink: 0; opacity: 0.55;', lsec > 0 ? fmtTime(lsec) : t.len);
      row.appendChild(name);
      row.appendChild(len);
      refs.listWrap.appendChild(row);
    });
  }

  function buildPill() {
    /* closed-state pill, verbatim from Home v3 lines 1160-1162 */
    pillEl = el('button',
      "position: fixed; right: 24px; bottom: 24px; z-index: 600; background: #43342B; color: #FDF6E3; border: 1.5px solid #43342B; border-radius: 999px; padding: 11px 20px; font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; font-family: 'Space Mono', monospace; cursor: pointer; box-shadow: 4px 4px 0 rgba(67,52,43,0.35);",
      '✺ radio');
    pillEl.className = 'twb-hov-terra';
    pillEl.addEventListener('click', function () { openRadio(); });
    document.body.appendChild(pillEl);
  }

  function syncTitles() {
    var title = currentTrack().title;
    var nodes = document.querySelectorAll('[data-twb-radio-title]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = title;
  }

  function fmtTime(sec) {
    sec = Math.floor(sec || 0);
    if (!isFinite(sec) || sec < 0) sec = 0;
    var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    var mm = h > 0 && m < 10 ? '0' + m : '' + m;
    var ss = s < 10 ? '0' + s : '' + s;
    return (h > 0 ? h + ':' : '') + mm + ':' + ss;
  }

  function parseLen(str) {
    if (!str) return 0;
    var p = String(str).split(':').map(Number);
    for (var i = 0; i < p.length; i++) { if (isNaN(p[i])) return 0; }
    var s = 0;
    for (var j = 0; j < p.length; j++) s = s * 60 + p[j];
    return s;
  }

  /* Paint the progress bar + the elapsed-time readout. Real audio reports its
     true currentTime; the synth/fallback derives elapsed from progress × the
     track's label length so the counter stays consistent with the bar. */
  function paintProgress() {
    if (refs.fill) refs.fill.style.width = (state.progress * 100).toFixed(1) + '%';
    if (!refs.elapsed) return;
    if (_activeSource === 'audio' && _audioEl && isFinite(_audioEl.duration) && _audioEl.duration > 0) {
      refs.elapsed.textContent = fmtTime(_audioEl.currentTime);
    } else {
      refs.elapsed.textContent = fmtTime(state.progress * parseLen(currentTrack().len));
    }
  }

  function sync() {
    syncTitles();
    if (!winEl) return;
    /* chips */
    refs.chips.forEach(function (c) {
      var active = c.id === state.channel;
      c.btn.style.background = active ? tokens.accentB : 'transparent';
      c.btn.style.color = active ? tokens.onAccent : tokens.ink;
    });
    /* screen */
    var cur = currentTrack();
    refs.screenText.textContent = (state.playing ? '▶' : '❚❚') + ' ' + cur.title;
    var totalSec = parseLen(cur.len);
    refs.len.textContent = totalSec > 0 ? fmtTime(totalSec) : cur.len;
    paintProgress();
    /* transport */
    refs.playBtn.textContent = state.playing ? '❚❚' : '▶';
    /* tracklist */
    renderTracklist();
    /* listen-on links: podcast channel only */
    if (refs.linksRow) {
      var hasLinks = _radioLinks && (_radioLinks.spotify || _radioLinks.apple || _radioLinks.youtube);
      if (state.channel === 'podcast' && hasLinks) {
        refs.linksRow.textContent = '';
        refs.linksRow.appendChild(el('span', 'opacity: 0.55; text-transform: uppercase; letter-spacing: 0.1em; color: ' + tokens.mut + ';', 'listen on'));
        var LISTEN_LABELS = { spotify: 'Spotify', apple: 'Apple', youtube: 'YouTube' };
        ['spotify', 'apple', 'youtube'].forEach(function (k) {
          if (!_radioLinks[k]) return;
          var a = el('a', 'color: ' + tokens.ink + '; text-decoration: none; border-bottom: 1.5px solid ' + tokens.accentC + '; padding-bottom: 1px;', LISTEN_LABELS[k] + ' ↗');
          a.href = _radioLinks[k]; a.target = '_blank'; a.rel = 'noopener';
          a.className = 'twb-hov-fade';
          refs.linksRow.appendChild(a);
        });
        refs.linksRow.style.display = 'flex';
      } else {
        refs.linksRow.style.display = 'none';
      }
    }
  }

  function render() {
    if (state.open) {
      if (!winEl) buildWindow();
      applyWinPos();
      sync();
    } else if (winEl) {
      if (winEl.parentNode) winEl.parentNode.removeChild(winEl);
      winEl = null;
      refs = {};
    }
    var showPill = !state.open && getMode() === 'site';
    if (showPill && !pillEl) {
      buildPill();
    } else if (!showPill && pillEl) {
      if (pillEl.parentNode) pillEl.parentNode.removeChild(pillEl);
      pillEl = null;
    }
    if (!state.open) syncTitles();
  }

  /* ---------- actions (exact behavior port) ---------- */

  /* half-second cassette spin-up on channel change — synthesized, gated by
     the OS "UI sounds" preference (twb-sfx, default on) */
  function tapeSpin() {
    try {
      if (localStorage.getItem('twb-sfx') === '0') return;
      ensureAudio();
      if (!_actx || !_master) return;
      if (_actx.state === 'suspended') _actx.resume();
      var t = _actx.currentTime + 0.02;
      /* motor pitch-up */
      var o = _actx.createOscillator(), g = _actx.createGain();
      o.type = 'sawtooth';
      o.frequency.setValueAtTime(70, t);
      o.frequency.exponentialRampToValueAtTime(240, t + 0.32);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(0.05, t + 0.05);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
      o.connect(g); g.connect(_master); o.start(t); o.stop(t + 0.45);
      /* tape hiss burst */
      var len = Math.floor(_actx.sampleRate * 0.35);
      var buf = _actx.createBuffer(1, len, _actx.sampleRate);
      var d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len) * 0.4;
      var n = _actx.createBufferSource(), ng = _actx.createGain();
      n.buffer = buf; ng.gain.value = 0.06;
      n.connect(ng); ng.connect(_master); n.start(t);
    } catch (e) {}
  }

  function selectChannel(id) {
    tapeSpin();
    destroyDeckCtl();
    state.deck = null;
    state.channel = id;
    state.progress = 0.02;
    /* a spotify tape has no engine — the deck IS its player */
    var t0 = (TRACKS[id] || [])[state.trackIdx[id] || 0] || {};
    if ((t0.kind || '') === 'spotify') {
      openDeck(t0);
      persistRadio({ channel: id, playing: false, progress: 0.02 });
      return;
    }
    state.playing = true;
    startAudio(id, state.trackIdx[id] || 0);
    persistRadio({ channel: id, playing: true, progress: 0.02 });
    sync();
  }

  function playTrack(i) {
    var ch = state.channel;
    state.trackIdx[ch] = i;
    state.progress = 0.02;
    state.playing = true;
    startAudio(ch, i);
    persistRadio();
    sync();
  }

  function setIdx(delta) {
    var l = TRACKS[state.channel];
    var cur = Math.min(state.trackIdx[state.channel] || 0, l.length - 1);
    var next = (cur + delta + l.length) % l.length;
    state.trackIdx[state.channel] = next;
    state.progress = 0.02;
    var t = l[next] || {};
    if ((t.kind || '') === 'spotify') {
      if (state.deck === t && _deckCtl) return; /* same tape already in the deck */
      destroyDeckCtl();
      openDeck(t);
      persistRadio({ playing: false });
      return;
    }
    if (state.deck) { destroyDeckCtl(); state.deck = null; }
    state.playing = true;
    startAudio(state.channel, next);
    persistRadio();
    sync();
  }

  /* resume the paused source in place where possible (don't restart from 0) */
  function resumeAudio() {
    var track = (TRACKS[state.channel] || [])[state.trackIdx[state.channel] || 0] || {};
    if (_activeSource === 'audio' && _audioEl && _audioEl.src && track.kind !== 'soundcloud' && track.src) {
      var p = _audioEl.play(); if (p && p.catch) p.catch(function () {}); return;
    }
    if (_activeSource === 'soundcloud' && _scWidget && track.kind === 'soundcloud') {
      scResume(); return;
    }
    /* nothing to resume in place (synth, or source changed) -> (re)start */
    startAudio(state.channel, state.trackIdx[state.channel] || 0);
  }

  function togglePlay() {
    /* spotify tape: the transport drives the embed controller, not an engine */
    if (currentIsSpotify()) {
      if (!state.deck) { openDeck(currentTrack()); return; }
      if (_deckCtl) {
        /* optimistic flip — playback_update confirms/corrects */
        state.playing = !state.playing;
        if (refs.playBtn) refs.playBtn.textContent = state.playing ? '\u275a\u275a' : '\u25b6';
        try { _deckCtl.togglePlay(); } catch (e) {}
      }
      return;
    }
    var playing = !state.playing;
    state.playing = playing;
    if (playing) resumeAudio();
    else pauseAudio();
    persistRadio({ playing: playing });
    sync();
  }

  function openRadio(opts) {
    if (opts) {
      if (opts.channel && TRACKS[opts.channel]) state.channel = opts.channel;
      if (typeof opts.trackIdx === 'number') state.trackIdx[state.channel] = opts.trackIdx;
    }
    state.open = true;
    if (opts && opts.playing === false) {
      /* open WITHOUT autoplay — design's enterOS path (Home v3 line 2449:
         setState({ radioOpen: true }) leaves playing untouched/paused) */
      persistRadio({ open: true });
      render();
      return;
    }
    state.playing = true;
    startAudio(state.channel, state.trackIdx[state.channel] || 0);
    persistRadio({ open: true, playing: true });
    render();
  }

  function closeRadio() {
    destroyDeckCtl();
    state.deck = null;
    state.open = false;
    state.playing = false;
    pauseAudio();
    persistRadio({ open: false, playing: false });
    render();
  }

  /* ---------- public API ---------- */

  window.TWBRadio = {
    open: function (opts) { openRadio(opts); },
    close: function () { closeRadio(); },
    minimize: function () { state.open = false; persistRadio({ open: false }); render(); },
    toggle: function () { if (state.open) closeRadio(); else openRadio(); },
    play: function () { if (!state.playing) togglePlay(); },
    pause: function () { if (state.playing) togglePlay(); },
    setTokens: function (t) {
      tokens = merge(RIVIERA, t || null);
      if (winEl) {
        if (winEl.parentNode) winEl.parentNode.removeChild(winEl);
        winEl = null;
        refs = {};
      }
      render();
    },
    setVolume: function (n) {
      n = Math.max(1, Math.min(8, Math.round(n) || 1));
      state.volume = n;
      if (_master) _master.gain.value = n / 12;          /* synth */
      if (_audioEl) _audioEl.volume = n / 8;             /* <audio> */
      if (_scWidget && _scReady) { try { _scWidget.setVolume((n / 8) * 100); } catch (e) {} } /* SoundCloud 0..100 */
    },
    getState: function () {
      return {
        open: state.open,
        channel: state.channel,
        trackIdx: merge(state.trackIdx),
        playing: state.playing,
        progress: state.progress
      };
    },
    _el: function () { return winEl; },
    _open: function () { return state.open; }
  };

  /* ---------- global listeners + timers ---------- */

  window.addEventListener('pointermove', function (e) {
    if (_rsz) {
      e.preventDefault();
      /* viewport cap must beat the size floor, or a landscape phone gets a
         window taller than its screen that can never be shrunk back */
      winEl.style.width = Math.min(window.innerWidth - 20, Math.max(300, _rsz.startW + e.clientX - _rsz.sx)) + 'px';
      winEl.style.height = Math.min(window.innerHeight - 80, Math.max(350, _rsz.startH + e.clientY - _rsz.sy)) + 'px';
      return;
    }
    if (!_drag) return;
    e.preventDefault();
    var x = Math.max(8, Math.min(window.innerWidth - 120, e.clientX - _drag.dx));
    var y = Math.max(44, Math.min(window.innerHeight - 64, e.clientY - _drag.dy));
    state.pos = { x: x, y: y };
    applyWinPos();
  });
  window.addEventListener('pointerup', function () { _drag = null; _rsz = null; });
  window.addEventListener('pointercancel', function () { _drag = null; _rsz = null; });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-twb-open-radio]') : null;
    if (!t) return;
    e.preventDefault();
    openRadio();
  });

  /* progress tick: +0.0035 per 250ms while playing & open.
     For real sources the bar is driven by the engine's own time events
     (timeupdate / PLAY_PROGRESS), so the dumb tick only runs for the synth. */
  setInterval(function () {
    if (state.playing && state.open && _activeSource !== 'audio' && _activeSource !== 'soundcloud' && _activeSource !== 'spotify') {
      state.progress = state.progress + 0.0035 > 1 ? 0 : state.progress + 0.0035;
      paintProgress();
    }
  }, 250);

  /* persist every 2s while open OR still playing (minimised to the pill), so a
     resumable position survives even if the tab is closed while minimised */
  setInterval(function () { if (state.open || state.playing) persistRadio(); }, 2000);

  /* re-evaluate pill when the entry mode changes */
  if (window.MutationObserver) {
    new MutationObserver(function () { render(); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['data-twb-entry'] });
  }

  function init() {
    hydrateTracks();
    restoreRadio();
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
